import React, { useState, useEffect, useCallback } from 'react';
import OiCarousel from 'components/shared/OiCarousel';

const RECOMMENDED_POSTS_CAROUSEL_BREAKPOINTS = [
  { minWidth: 375, slidesPerView: 1.2 },
  { minWidth: 425, slidesPerView: 2.2 },
  { minWidth: 768, slidesPerView: 3 },
];

function hoverTintFromPost(post) {
  const s = `${post?.id ?? ''}:${post?.slug ?? ''}`;
  let x = 0;
  for (let i = 0; i < s.length; i++) {
    x = (x * 31 + s.charCodeAt(i)) >>> 0;
  }
  const k = 12;
  const hue = ((x % k) * (360 / k)) | 0;
  const sat = 66 + ((x >>> 4) % 4) * 6;
  const light = 40 + ((x >>> 8) % 3) * 5;
  return `hsla(${hue}, ${sat}%, ${light}%, 0.14)`;
}

function CarouselRecommendedPosts({ posts: postsProp }) {
  const posts = Array.isArray(postsProp) ? postsProp : [];
  const postIds = posts.map((post) => post.id).join(',');
  const [imagesLoaded, setImagesLoaded] = useState({});

  const markImageLoaded = useCallback((postId, imgEl) => {
    if (imgEl) imgEl.classList.remove('blur');
    setImagesLoaded((prev) => {
      if (prev[postId]) return prev;
      return { ...prev, [postId]: true };
    });
  }, []);

  useEffect(() => {
    const next = {};
    posts.forEach((post) => {
      next[post.id] = !post.cover_f;
    });
    setImagesLoaded(next);
  }, [postIds]);

  useEffect(() => {
    posts.forEach((post) => {
      if (!post.cover_f) return;
      const img = document.getElementById(`recommended-post-img-${post.id}`);
      if (img && img.complete) markImageLoaded(post.id, img);
    });
  }, [postIds, posts, markImageLoaded]);

  if (posts.length === 0) return null;

  return (
    <section className="caroussel recommended-posts-carousel">
      <section className="products-section">
        <OiCarousel
          className="oi-carousel--bleed"
          items={posts}
          gap={0}
          breakpoints={RECOMMENDED_POSTS_CAROUSEL_BREAKPOINTS}
          ariaLabel="Artículos recomendados"
          prevButtonId="oi-recommended-posts-prev"
          nextButtonId="oi-recommended-posts-next"
          getItemKey={(post) => `recommended-post-${post.id}`}
          renderItem={(post) => (
            <article className="post-grid">
              <div
                className="post-wraper home-blog-card-stack"
                style={{ '--product-card-hover-overlay': hoverTintFromPost(post) }}
              >
                <a
                  className="post-grid-link oi-flex oi-flex-column"
                  href={post.url}
                  title="View Details"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {post.cover_f && (
                    <figure className="recommended-posts-carousel-figure">
                      <img
                        id={`recommended-post-img-${post.id}`}
                        className="lazyload"
                        src={post.cover_f}
                        alt={post.title}
                        onLoad={(e) => markImageLoaded(post.id, e.currentTarget)}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = '/assets/phone.svg';
                          markImageLoaded(post.id, e.currentTarget);
                        }}
                      />
                      {!imagesLoaded[post.id] && (
                        <div
                          className="oi-skeleton oi-skeleton--wave oi-skeleton--cover oi-skeleton--rounded"
                          aria-hidden
                        />
                      )}
                    </figure>
                  )}
                  <div className="info-slide text-slide-fix oi-flex oi-flex-column">
                    <p className="zone h7">{post.label}</p>
                    <h4>{post.title}</h4>
                    {post.subtitle && <p className="subtile h5">{post.subtitle}</p>}
                    {(post.author_name || post.author_sm) && (
                      <p className="author h7">
                        {post.author_name && <strong>{post.author_name}</strong>}
                        {post.author_name && post.author_sm && ' | '}
                        {post.author_sm}
                      </p>
                    )}
                  </div>
                </a>
              </div>
            </article>
          )}
        />
      </section>
    </section>
  );
}

export default CarouselRecommendedPosts;
